import Icon from './Icon';
import { IconManifest } from './iconManifest';

export type IconType = IconManifest;

export default Icon;
